import React, { useEffect, useLayoutEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ICouponProps } from "./Coupon.types";
import {
  useFlowData,
  Icon,
  IconColorStyle,
  IconSize,
  FlowTypes,
  subscribeDataChange,
  unsubscribeDataChange,
  setFlowDataDirect,
  getFlowDataDirect,
  timeout,
  handleSendKlaviyoEvents,
  logEvent,
  updateQuoteNumberToPets
} from "@adaptis/flow-components";
import {
  getPaymentFrequencyLabel,
  setQuoteData,
  logQuote,
  setPetOriginalModel,
  getPetOriginalModel,
  getOriginalPostCode,
  setOriginalPostCode,
  getPetQty
} from "../../util/data-store";
import LoadingLightbox from "../LoadingLightbox";
import { getQuote } from "../../util/knose-api-wrapper";
import { klaviyoTrack, pushDataToGTM, getPetAge, callApiSaveQuote } from "../../KnoseAPI/Lib/Utils";
import "./Coupon.scss";
import { PetType, Pets, IPet } from "../../util/common-types";
import { getPetIndexFromId, getAFXProfile } from "../../util/helper-functions";
import { Button } from "react-bootstrap";
import Config from "../../app-config";
import pLimit from 'p-limit';
const limit = pLimit(1);

export default function Coupon(props: ICouponProps) {
  const location = useLocation();
  const { getData, setData, getDataFromArray } = useFlowData();
  const query = new URLSearchParams(location.search);
  const [coupon, setCoupon] = React.useState("");
  const [isBlockStyle, setIsBlockStyle] = useState(false);
  const [couponBannerHidden, setCouponBannerHidden] = useState(false);
  const [loadingPrice, setLoadingPrice] = React.useState(false);
  const [isRender, setIsRender] = React.useState(true);
  const [currentPromoCodeModel, setCurrentPromoCodeModel] = React.useState<FlowTypes.IFlowPromotionCode>();
  let pets: Pets = React.useMemo(() => getData(props.dataField ?? ""), []);
  let petQty = getPetQty(pets);
  useEffect(() => {
    checkAndUpdatePrice();
  }, [petQty])

  useLayoutEffect(() => {
    if (!props) return;
    if (props.className) {
      if (props.className.includes("block-style")) {
        setIsBlockStyle(true);
      }
    }

    if (getCouponBannerHiddenProp()) {
      setCouponBannerHidden(true);
    }
  }, [couponBannerHidden]);

  useEffect(() => {
    //PPP-11
    setIsBlockStyle(props.showCloseButton ? true : false);
    let promoCode = getData("root.promoCode");
    if (promoCode) setCoupon(promoCode);
    if (getCurrentUrlKey(1) === 'custom-cover') return;

    checkAndUpdatePrice();
  }, []);

  function setPromoModel() {
    let selectedPromoCode: FlowTypes.IFlowPromotionCode = getData("root.selectedPromoCode");
    if (selectedPromoCode) {
      setIsRender(props.isRender || selectedPromoCode.type == 3);
      setCurrentPromoCodeModel(selectedPromoCode);
    }
  }

  useEffect(() => {
    // Anything in here is fired on component mount.
    subscribeDataChange("PromoCodeChangeCoupon", handlePromoCodeChange);
    setCoupon(getData("root.promoCode") ?? "");
    setPromoModel();

    return () => {
      // Anything in here is fired on component unmount.
      unsubscribeDataChange("PromoCodeChangeCoupon");
    };
  }, [coupon]);

  function handlePromoCodeChange(
    dataPath: string,
    dataField: string,
    data: any
  ) {
    if (dataField === "promoCode") {
      setCoupon(data);
      checkAndUpdatePrice();
    } else if (dataField === "selectedPaymentFrequency") {
      checkAndUpdatePrice();
    }
  }

  async function handleCouponCloseButton() {
    setData("root.isInvalidPromotionCode", false);
    setFlowDataDirect("isSavedQuote", false);
    setFlowDataDirect("isChangedData", false);
    setData("root.promoCode", null);
  }

  async function checkAndUpdatePrice() {
    let isSavedQuote = getFlowDataDirect("isSavedQuote");
    if (isSavedQuote) return;
    let promoCode = getData("root.promoCode");
    let multiPetPromoCode: string = getFlowDataDirect("multiPetPromoCode");
    let allPets = getData("root.pets");
    let validPets = Array.isArray(allPets)
      ? allPets.filter((pet: any) => pet.customCover)
      : Object.values(allPets || {}).filter((pet: any) => pet.customCover);
    let petsUpdate: string[] = [];
    let petIndex = -1;
    if (promoCode) {
      validPets.forEach((pet: any, index: number) => {
        if (pet.customCover.promoCode !== promoCode) {
          petIndex = getPetIndexFromId(pet.pet_no, allPets);
          // console.log("petIndex", petIndex, pet.id);
          setData(`pets[${petIndex}].customCover.promoCode`, promoCode);
          petsUpdate.push(pet.id);
        }
      });
    } else {
      let petId = getData("id");
      if (petId && validPets.length >= 1) {
        validPets.forEach((pet: any, index: number) => {
          petIndex = getPetIndexFromId(pet.pet_no, allPets);
          if (validPets[index].customCover.promoCode && validPets[index].customCover.promoCode !== multiPetPromoCode) {
            setData(`pets[${petIndex}].customCover.promoCode`, null);
            petsUpdate.push(pet.id);
          }
        });
      }
    }

    if (petsUpdate.length) {
      //get new data
      let quote;
      const timeoutError = Symbol();
      setLoadingPrice(true);
      try {
        allPets = getData("root.pets");
        const result = await timeout(
          getQuote(allPets),
          Config.websevice_timeout,
          timeoutError
        );
        if (!result || !result.data || (result.data.process != result.data.total)) {
          const { errMsg } = result.data;
          // console.log("PPP-159 errMsg", errMsg);
          if (errMsg) {
            let isPromocodeInvalid = errMsg.find((item: any) => item.includes('Promo code invalid'));
            setData("root.isInvalidPromotionCode", isPromocodeInvalid ? true : false);
            // console.log("PPP-159 isPromocodeInvalid 2", isPromocodeInvalid);
          }
          // console.log("PPP-159 corrver", result);
          throw ["Error quote result is invalid", result];
        }
        quote = result.data.quote;
      } catch (e: any) {
        if (e === timeoutError) {
          // handle timeout
          console.log("getPrice() Timeout");
          setLoadingPrice(false);
          logEvent(
            "error-timeout",
            true,
            "getPrice() Timeout = " + Config.websevice_timeout
          );
          return;
        } else {
          // other error
          console.log("getPrice() Error", e);
          // throw e;
          setLoadingPrice(false);
          logEvent("error", true, "SelectedCover->getPrice()", e);
          return;
        }
      }

      quote.pets.forEach((pet: any) => {
        let { premiums, promo } = pet;
        let petIndex = getPetIndexFromId(pet.pet_no, allPets);
        if (petIndex >= 0) {
          setData(`pets[${petIndex}]["customCover"].premiums`, premiums);
          setData(`pets[${petIndex}]["customCover"].promo`, promo ? promo : null);
        }
        if (promoCode && promo) {
          setData("root.promoCodeType", parseInt(promo.promoType.replace("Type", '')));
        }
      });

      //Save quote
      // Prepare quote payload
      const sessionId = getData('root.sessionId') ?? '';
      const quoteNumber = getData('root.petsyQuoteNumber') ?? '';
      const parentQuoteNumber = getData('root.parentQuoteNumber') ?? '';
      const landingPage = getData('root.landingPage') ?? '';
      const holderEmail = getData('root.holderEmail') ?? '';
      const costcoMemberNumber = getData('root.costcoMemberNumber') ?? '';
      let adfixusID = getAFXProfile();
      if (adfixusID === '(not set)') {
        adfixusID = '';
      }
      // let pets = getData('root.pets') ?? [];
      let updateKlaviyoPets = allPets.filter((pet: any) => pet.breed);
      let petsDataPayload = updateKlaviyoPets.map((pet: any) => {
        return {
          "email": holderEmail,
          "Session_id": sessionId,
          "id": pet ? pet.id : "",
          "petType": pet ? pet.petType : "",
          "petTypeIndex": pet ? pet.petTypeIndex : "",
          "petOrdinalName": pet ? pet.petOrdinalName : "",
          "petShowedPopup": pet ? pet.isShowedPopup : "",
          "name": pet ? pet.name : "",
          "isValid": pet ? pet.isValid : "",
          "isTouched": pet ? pet.isTouched : "",
          "breed": pet ? pet.breed : "",
          "petDOB": pet ? pet.petDOB : "",
          "petAgeOnStartDatePolicy": pet ? pet.petAgeOnStartDatePolicy : "",
          "petSex": pet ? pet.petSex : "",
          "isDesexed": pet ? pet.isDesexed : "",
          "startDate": pet ? pet.startDate : "",
          "customCover": pet ? pet.customCover : "",
          "coverType": pet ? pet.coverType : "",
          "petAgeCategory": pet ? pet.petAgeCategory : "0",
          "quoteNumber": pet ? pet.customCover.quoteNumber : null,
          "parentQuoteNumber": parentQuoteNumber ?? null,
          "channel": "CostoQT",
          "Adfixus_ID": adfixusID,
          landingPage,
          CostcoMemberID: costcoMemberNumber
        };
      });

      const quotePayload = {
        sessionId: sessionId,
        quoteNumber: quoteNumber,
        parentQuoteNumber: parentQuoteNumber,
        pets: petsDataPayload,
        profile: {
          Holder_Email: holderEmail,
          Holder_First_Name: getData('root.holderFirstName') ?? '',
          Holder_Last_Name: getData('root.holderLastName') ?? '',
          Holder_DOB: getData('root.holderDOB') ?? '',
          Holder_Phone: getData('root.holderPhone') ?? '',
          Holder_Post_Code: getData('root.holderAddress.postcode') ?? '',
          Holder_State: getData('root.holderAddress.state') ?? '',
          Holder_Suburb: getData('root.holderAddress.suburb') ?? '',
          Holder_Address_Line_1: getData('root.holderAddress.line1') ?? '',
          Holder_Address_Line_2: getData('root.holderAddress.line2') ?? '',
          Holder_Costco_Member_Number: costcoMemberNumber,
          Session_id: sessionId,
          channel: 'CostoQT',
        },
      };
      // Call save-quote API
      let quoteSaveData = await callApiSaveQuote(quotePayload);
      if (quoteSaveData && quoteSaveData.success && quoteSaveData.data) {
        await updateQuoteNumberToPets(quoteSaveData);
        setData('root.quoteNumber', quoteSaveData.data.quoteNumber);
      }

      let promiseList: any[] = [];
      for (let pet of updateKlaviyoPets) {
        promiseList.push(
          handleSendKlaviyoEvents("Custom_Cover_Details", [pet])
            .catch((error) => {
              console.error(`Failed to send Klaviyo event for pet ${pet.id}:`, error);
              // Return null instead of throwing to prevent Promise.all from failing
              return null;
            })
        );
      }

      try {
        const results = await Promise.all(promiseList);
        const successCount = results.filter(result => result !== null).length;
        const failureCount = results.filter(result => result === null).length;

        if (failureCount > 0) {
          console.warn(`Klaviyo events: ${successCount} successful, ${failureCount} failed`);
        } else {
          console.log(`All ${successCount} Klaviyo events sent successfully`);
        }
      } catch (error) {
        console.error("Error sending Klaviyo events:", error);
        // Continue execution even if Klaviyo events fail
      }

      setLoadingPrice(false);
    }
  }

  function getCurrentUrlKey(index: number = 2) {
    return location.pathname.split('/')[index] ?? '';
  }

  function getCouponBannerHiddenProp() {
    let couponBannerHidden = getData("root.couponBannerHidden");
    if (!couponBannerHidden) {
      return false;
    }

    if (couponBannerHidden === true) return true;
    return false;
  }

  function renderCoupon(): JSX.Element {
    // console.error("loadingPrice", loadingPrice);
    return ((!isRender || props.fixIsNoRender) ? <></> :
      <div
        data-testid="Coupon"
        className={
          `flc_coupon text-center ${props.className ? props.className : ""} ${coupon.length >= 15 && coupon.length <= 20 ? 'middle-length' : ''} ${coupon.length >= 20 ? 'long-length' : ''}`
        }
      >
        <LoadingLightbox show={loadingPrice} title="Loading your Quote..." />
        {isBlockStyle && (
          <>
            <Button
              className="close-coupon-btn"
              variant=""
              onClick={(e) => {
                e.preventDefault();
                handleCouponCloseButton();
              }}
            >
              X
            </Button>
          </>
        )}
        <div className={`first-col`}>
          <div className="img-wrapper">
            {/* <img src={currentPromoCodeModel?.imgSrc ?? ""} /> */}
            <img src="/images/promotion-code-icon.png" />
          </div>
          <div className={`coupon-value-wrapper`}>
            <span>
              <b>{coupon}</b>
            </span>
          </div>
        </div>
        <div className="second-col">
          <div className="coupon-description-wrapper">
            <span>{currentPromoCodeModel?.promotionMessage}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {
        ((coupon && !couponBannerHidden && isBlockStyle) || (coupon && !isBlockStyle)) ? renderCoupon() : <></>
      }
      <LoadingLightbox show={loadingPrice} title="Loading your Quote..." />
    </>
  )
}
